//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../Mechatronics/Mechatronics.SelectRigidBody.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"AttachBody",0,"Mechatronics.SelectRigidBody",0],[0,"AttachPoint",1,"Point",0],[0,"Category",1,0],[0,"EnableBond",1,0],[0,"JunctionName",1,0],[0,"Name",1,0],[0,"Orientation",1,"CoordinateSystem",0],[1,"Proximity",0,"Expression",0],[0,"SnapRole",1,0]],[[["rigid"],"SetAttachbody",{},1,0]],[]];
SPLM.Mechatronics.AlignBodyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.AlignBodyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.AlignBodyBuilder.RoleType = Object.freeze({
    "Source" : "Source", "Target" : "Target"});

export default SPLM;